<template>
  <cmp-site-container>
    <!-- 
    - Display a page header
    -->
    <mp-page-header
      title="Users"
      subtitle="Manager users and view their status"
    >
      <div slot="actions">
        <mp-btn icon="add" @click="showAddForm = true">Add User</mp-btn>
      </div>
    </mp-page-header>

    <!-- 
    - Display an add server form
     -->
    <users-add-user
      :show="showAddForm"
      @close="showAddForm = false"
      @input="serverAdded"
    />

    <!-- 
    - display an object list
     -->
    <cmp-content-block title="Users">
      <users-user-list ref="list" />
    </cmp-content-block>
  </cmp-site-container>
</template>

<script>
import CmpSiteContainer from "@/components/Structural/SiteContainer";
import CmpContentBlock from "@/components/Structural/ContentBlock";
export default {
  name: "UsersController",
  components: { CmpContentBlock, CmpSiteContainer },
  data() {
    return {
      showAddForm: false
    };
  },
  methods: {
    serverAdded() {
      this.showAddForm = false;
      if (
        this.$refs.hasOwnProperty("list") &&
        this.$refs.list.hasOwnProperty("load")
      ) {
        this.$refs.list.load();
      }
    }
  }
};
</script>

<style scoped></style>
